import { IsNotEmpty, IsString, ValidateIf } from "class-validator";
import { FileVariantsEnum } from '../../enums';

export class FileDto {
	public id: string;
	public fileName: string;
	public mimeType: string;
	public size: number;
	public key: string;
	public isPublic: boolean;
	public variant: FileVariantsEnum;
	public parentId: string | null;
	public previewId?: string;
	public jobId?: string;
	public jobSuccessful?: boolean;
	public jobStartedAt?: Date;
	public jobFinishedAt?: Date;
	public createdAt?: Date;
	public updatedAt?: Date;
	public deletedAt?: Date;
	public properties?: FileProperties;
	public variants?: FileDto[];
	public parent?: FileDto;
	public isTemp?: boolean;
	public url?: string;
}

export class FileUploadDto {
	@IsNotEmpty()
	@IsString()
	public fileName: string;

	@ValidateIf((o) => !o.key)
	@IsNotEmpty()
	@IsString()
	public base64EncodedFile?: string;

	@ValidateIf((o) => !o.base64EncodedFile)
	@IsNotEmpty()
	@IsString()
	public key?: string;

	public type?: 'image' | 'video';

	public isTemp?: boolean;
}

export class ImageCompressingOptions {
	public maxWidth: number | null;
	public maxHeight: number | null;
	public variants?: Pick<
		Record<FileVariantsEnum, Omit<ImageCompressingOptions, 'variants'>>,
		FileVariantsEnum.M | FileVariantsEnum.S | FileVariantsEnum.XS
	>
}

export class VideoCompressingOptions {
	public maxWidth: number;
	public maxHeight: number;
	public fps: number;
}

export class GetSignedUrlToUploadFileParams {
	@IsNotEmpty()
	@IsString()
	public contentType: string;
}

export class FileProperties {
	public width?: number;
	public height?: number;
	public duration?: number;
	public frameRate?: number;
	public frameCount?: number;
	public resolution?: string;
	public aspectRatio?: number;
}

export class FileToUserDto {
	public id: string;
	public userId: string;
	public fileId: string;
}
